import React, {useState, useEffect} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import {useNavigate} from 'react-router-dom';
import {useFormik} from 'formik';
import {toast} from 'react-toastify';
import {ContentHeader} from '@components';
import {logoutUser} from '@store/reducers/auth';
import {createCase} from '@app/services/case';
import {getAllAdminName} from '@app/services/leaves';
import {getAllCategoryName} from '@app/services/category';
import {createActivity} from '@app/services/activity';
import {type} from '../../config';
import handleStatus from '../../utils/ajax';

const CreateCase = () => {
  const [users, setUsers] = useState([]);
  const [category, setCategory] = useState([]);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const userName = useSelector(
    (state: any) => state.auth.currentUser?.data?.name
  );

  const initialValues = {
    profile: '',
    type: '',
    title: '',
    link: '',
    chatLink: '',
    categoryId: '',
    reply: '',
    closed: '',
    clientName: '',
    points: ''
  };
  const onSubmit = async (values) => {
    if (formik.values.reply === 'Yes') {
      formik.values.reply = true;
    }
    if (formik.values.reply === 'No') {
      formik.values.reply = false;
    }

    if (formik.values.reply === '') {
      formik.values.reply = false;
    }

    if (formik.values.closed === 'Yes') {
      formik.values.closed = true;
    }
    if (formik.values.closed === 'No') {
      formik.values.closed = false;
    }
    if (formik.values.closed === '') {
      formik.values.closed = false;
    }
    const res = await createCase(values);
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);
    if (res.status === 200) {
      const payload = {
        caseId: res.data.data._id,
        activityType: 'Comment',
        removeFollowUp: false,
        comment: `Case created by ${userName}`
      };
      const create = await createActivity(payload);
      handleStatus(create.status, () => dispatch(logoutUser()), navigate);
      if (create.status === 200) {
        toast.success('Case has been created');
        navigate('/all-cases');
      }
    }
  };
  const validate = (values) => {
    let errors = {};
    if (values.profile === '') {
      errors.profile = 'Please select a profile';
    }

    if (values.categoryId === '') {
      errors.categoryId = 'Please select a category';
    }

    if (values.type === '') {
      errors.type = 'Please Enter type';
    }
    if (!values.title) {
      errors.title = 'Please Enter title';
    }
    if (!values.link) {
      errors.link = 'Please Enter link';
    }

    if (!values.points) {
      errors.points = 'Please Enter credits';
    }

    return errors;
  };

  const formik = useFormik({
    initialValues,
    validate,
    onSubmit
  });

  const getAllAdmin = async () => {
    const res = await getAllAdminName();
    handleStatus(res.status, () => dispatch(logoutUser()), navigate);
    if (res.data.ok) {
      setUsers(
        res.data.data.map((user) => ({value: user._id, label: user.name}))
      );
    }
  };

  const getAllCategory = async () => {
    const result = await getAllCategoryName();
    handleStatus(result.status, () => dispatch(logoutUser()), navigate);

    if (result.data.ok) {
      setCategory(
        result.data.data.map((user) => ({
          value: user._id,
          label: user.category
        }))
      );
    }
  };

  useEffect(() => {
    getAllAdmin();
    getAllCategory();
  }, []);

  return (
    <>
      <ContentHeader title="Create Case" path="/all-cases" />
      <section className="content">
        <div className="row">
          <div className="col-md-12">
            <div className="card card-outline card-info">
              <div className="card-header">
                <h3 className="card-title">Create Case</h3>
              </div>
              <div className="card-body">
                <div className="row">
                  <div className="col-md-10">
                    <div className="card card-primary">
                      <form onSubmit={formik.handleSubmit}>
                        <div className="card-body">
                          <div className="form-group row">
                            <label
                              htmlFor="inputProfile"
                              className="col-sm-2 col-form-label"
                            >
                              Profile
                            </label>
                            <div className="col-sm-10">
                              <select
                                className="form-control"
                                name="profile"
                                value={formik.values.profile}
                                onChange={formik.handleChange}
                              >
                                <option value="">Select an option...</option>
                                {users.map((val) => {
                                  return (
                                    <>
                                      <option value={val.value}>
                                        {val.label}
                                      </option>
                                    </>
                                  );
                                })}
                              </select>
                              {formik.touched.profile &&
                              formik.errors.profile ? (
                                <div className="error-message">
                                  {formik.errors.profile}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputProfile"
                              className="col-sm-2 col-form-label"
                            >
                              Category
                            </label>
                            <div className="col-sm-10">
                              <select
                                className="form-control"
                                name="categoryId"
                                value={formik.values.categoryId}
                                onChange={formik.handleChange}
                              >
                                <option value="select">
                                  Select an option...
                                </option>
                                {category.map((val) => {
                                  return (
                                    <>
                                      <option value={val.value}>
                                        {val.label}
                                      </option>
                                    </>
                                  );
                                })}
                              </select>
                              {formik.touched.categoryId &&
                              formik.errors.categoryId ? (
                                <div className="error-message">
                                  {formik.errors.categoryId}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputType"
                              className="col-sm-2 col-form-label"
                            >
                              Type
                            </label>
                            <div className="col-sm-10">
                              <select
                                className="form-control"
                                name="type"
                                value={formik.values.type}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                              >
                                <option selected value="">
                                  Select an option...
                                </option>

                                {type.map((val) => {
                                  return (
                                    <>
                                      <option>{val}</option>
                                    </>
                                  );
                                })}
                              </select>
                              {formik.touched.type && formik.errors.type ? (
                                <div className="error-message">
                                  {formik.errors.type}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputTitle"
                              className="col-sm-2 col-form-label"
                            >
                              Title
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                name="title"
                                value={formik.values.title}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                id="inputTitle"
                                placeholder="abc"
                              />
                              {formik.touched.title && formik.errors.title ? (
                                <div className="error-message">
                                  {formik.errors.title}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputLink"
                              className="col-sm-2 col-form-label"
                            >
                              Link
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                name="link"
                                value={formik.values.link}
                                onChange={formik.handleChange}
                                id="inputLink"
                                placeholder="https//:abc.com"
                              />
                              {formik.touched.link && formik.errors.link ? (
                                <div className="error-message">
                                  {formik.errors.link}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputChat"
                              className="col-sm-2 col-form-label"
                            >
                              Chat Link
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                name="chatLink"
                                value={formik.values.chatlink}
                                onChange={formik.handleChange}
                                id="inputChat"
                                placeholder="abc"
                              />
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputName"
                              className="col-sm-2 col-form-label"
                            >
                              Credits
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="number"
                                className="form-control"
                                id="inputName"
                                onChange={formik.handleChange}
                                placeholder="Points"
                                name="points"
                                value={formik.values.points}
                              />
                              {formik.touched.points && formik.errors.points ? (
                                <div className="error-message">
                                  {formik.errors.points}{' '}
                                </div>
                              ) : null}
                            </div>
                          </div>

                          <div className="form-group row">
                            <label
                              htmlFor="inputReply"
                              className="col-sm-2 col-form-label"
                            >
                              Reply
                            </label>
                            <div className="col-sm-10">
                              <select
                                className="form-control"
                                name="reply"
                                value={formik.values.reply}
                                onChange={formik.handleChange}
                              >
                                <option value="">Select an option...</option>
                                <option>Yes</option>
                                <option>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputClosed"
                              className="col-sm-2 col-form-label"
                            >
                              Closed
                            </label>
                            <div className="col-sm-10">
                              <select
                                className="form-control"
                                name="closed"
                                value={formik.values.closed}
                                onChange={formik.handleChange}
                              >
                                <option value="">Select an option...</option>
                                <option>Yes</option>
                                <option>No</option>
                              </select>
                            </div>
                          </div>
                          <div className="form-group row">
                            <label
                              htmlFor="inputName"
                              className="col-sm-2 col-form-label"
                            >
                              Client Name
                            </label>
                            <div className="col-sm-10">
                              <input
                                type="text"
                                className="form-control"
                                id="inputName"
                                onChange={formik.handleChange}
                                placeholder="Client Name"
                                name="clientName"
                                value={formik.values.clientName}
                              />
                            </div>
                          </div>
                          <button
                            type="submit"
                            className="btn btn-primary offset-md-2"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CreateCase;
